export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const toTermsAndConditions = () => `https://www.credilinq.ai/termsandcondition`

export const privacyPolicy = () => `https://www.credilinq.ai/privacy-policy`

export const toFinancingTermsAndConditions = () => `https://credilinq.ai/credilinq-financing-terms-conditions/`

export const toDrawdownTermsAndConditions = () => 'https://credilinq.ai/credilinq-drawdown-terms-conditions/'